import { useExitFormDialog } from "@dashboard/components/Form";
import React from "react";

/**
 * Tells the page's exit-form dialog that a fitment card holds unsaved edits,
 * so leaving the product page asks first. Each card registers as its own form
 * (its own id) because it saves itself, apart from the product form's Save.
 * The exit dialog only offers "keep editing" or "leave", so the registered
 * submit is a no-op; registration is what makes `setIsDirty` count (the
 * provider ignores an id it has no entry for, and drops every entry on each
 * navigation, hence registering again whenever the flag changes).
 * Switching product tabs is a query-only change the dialog never blocks; the
 * fitment tab stays mounted instead (ProductFitmentTab).
 */
export const useFitmentExitGuard = (dirty: boolean) => {
  const { setExitDialogSubmitRef, setIsDirty } = useExitFormDialog();

  React.useEffect(() => {
    setExitDialogSubmitRef(async () => []);
    setIsDirty(dirty);
    // The hook's setters are rebuilt per render; only the flag matters.
  }, [dirty]);

  React.useEffect(
    () => () => {
      setIsDirty(false);
    },
    [],
  );
};
